import React from 'react';
import { AreaPage } from '@/components/public/AreaPage';
import { ExperienceTicketShowcase } from '@/components/public/ExperienceTicketShowcase';

const config = {
  eyebrow: 'Experience',
  title: 'Esperienze in Sila',
  lead: 'Trekking, avventura, benessere e sapori: vivi la Sila attraverso chi la abita ogni giorno.',
  heroImage: 'https://images.pexels.com/photos/28127038/pexels-photo-28127038.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1920',
  intro: 'Ogni esperienza nasce dall\u2019incontro con le persone della Sila \u2014 guide, pastori, artigiani, giovani del territorio. Non semplici attivit\u00e0, ma immersioni autentiche dove i sensi si amplificano e le emozioni sgorgano.',
  bullets: [
    'Guide ed esperti locali certificati',
    'Piccoli gruppi e attenzione al dettaglio',
    'Percorsi per famiglie, coppie e avventurieri',
    'Natura, sport, benessere e cultura',
  ],
  // MOCK: al posto dei box marketing mostriamo i "biglietti" delle esperienze reali.
  features: [],
  ctaTitle: 'Pronto a partire?',
  ctaText: 'Sfoglia il catalogo completo e prenota la tua avventura in Sila.',
  ctaLabel: 'Sfoglia il catalogo',
  ctaTo: '/esperienze/catalogo',
};

export default function Esperienze() {
  return <AreaPage slug="experience" config={config} extra={<ExperienceTicketShowcase />} />;
}
